export const DIRECT_DEBIT_BANKS = [
    '0102',
    '0104',
    '0105',
    '0108',
    '0114',
    '0134',
    '0138',
    '0163',
    '0172',
    '0174',
    '0191',
];
